import React from 'react'
import StyledAnimationWrapper from "components/styled/AnimationWrapper.styled";
import StyledBackgroundWrapper from "components/styled/BackgroundWrapper.styled";
import sexOneBAnimation from "assets/animation/sex-one-b-animation.json";
import Lottie from "lottie-react";

const SvgSexThreeEnd = () => {
  return (
    <StyledBackgroundWrapper>
    <StyledAnimationWrapper top="12%" left="22%" width="8%">
      <Lottie animationData={sexOneBAnimation} loop={true} autoPlay={true} />
    </StyledAnimationWrapper>
    <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x={0}
    y={0}
    viewBox="0 0 961 1351.5"
    style={{
      enableBackground: "new 0 0 961 1351.5",
    }}
    xmlSpace="preserve"
  >
    <style>
      {
        ".st0{fill:none}.st5{fill:#aec663}.st6{fill:#bdd384}.st8{fill:#1b513c}.st9{fill:#f2b668}.st10{fill:#d89e60}.st12{fill:#4b968d}.st13{fill:#c3ddd9}.st15{fill:#bf5c61}.st22{fill:#e8a18e}.st23{fill:#894e46}.st24{opacity:.2;fill:#dd8172;enable-background:new}.st27{fill:#844339}.st29{fill:#9757a3}.st31{opacity:.2}.st32{fill:#dd8172}.st33{fill:#b56fc6}.st34{fill:#133f8e}.st37{fill:#f15931}.st39{fill:#9f5d4a}.st40{opacity:.2;fill:#9e695c;enable-background:new}.st41{fill:#382632}.st42{fill:#5b3f45}.st44{fill:#121d3b}.st45{fill:#fff}.st48,.st49{fill:none;stroke:#95a551;stroke-width:2;stroke-miterlimit:10}.st49{stroke:#aabc71}"
      }
    </style>
    <pattern
      y={1365}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="New_Pattern_Swatch_2"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path
        style={{
          fill: "#a2ce46",
        }}
        d="M0-104h131V0H0z"
      />
    </pattern>
    <pattern
      y={1365}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="New_Pattern_Swatch_4"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path
        style={{
          fill: "#13a89e",
        }}
        d="M0-104h131V0H0z"
      />
    </pattern>
    <pattern
      y={1365}
      width={131}
      height={104}
      patternUnits="userSpaceOnUse"
      id="New_Pattern_Swatch_6"
      viewBox="0 -104 131 104"
      style={{
        overflow: "visible",
      }}
    >
      <path className="st0" d="M0-104h131V0H0z" />
      <path className="st0" d="M0-104h131V0H0z" />
      <path
        style={{
          fill: "#eae2f0",
        }}
        d="M0-104h131V0H0z"
      />
    </pattern>
    <path
      d="M176.1 1010c-7.5 31.3-11.8 54.6-14.8 76.5h-66c1.9-68 22.7-79 20.7-151.8-.2-8.7-2.7-14.6-5.3-22.8h84.4c-5.5 21.3-5.7 35.4-6.2 48.2-1.6 39.3-12.8 49.9-12.8 49.9z"
      style={{
        fill: "#d69b6d",
      }}
    />
    <path
      className="st5"
      d="M363.9 1303.3H0v48.1h363.9c13.3 0 24.1-10.8 24.1-24.1 0-13.2-10.8-24-24.1-24z"
    />
    <path
      className="st5"
      d="M0 1307.7h360.1c-19.8-63.4-78.4-106.6-144.8-106.6 0-83.7-67.9-151.6-151.6-151.6-22.4 0-44 4.9-63.7 14v244.2z"
    />
    <path
      className="st6"
      d="M66.5 1222.9c-4.4-.7-8.8-1.1-13.2-1.1-16 0-31.7 4.7-45.1 13.7-2-6.5-4.7-12.6-8.2-18.3v98.7h133.1c7.3-44.1-22.6-85.8-66.6-93z"
    />
    <g id="Layer_15">
      <path
        d="m961 .5-962-3 1 1079v-68C303 708.8 503.9 766 630 732.8c55.9-14.7 165.6-81.3 192.9-132.2.5-1-.4 1.3.1.4 15.8-30.9 22.1-69.4 16-103.6C780.1 167.8 958 3.5 958 3.5"
        style={{
          fill: "#02594f",
        }}
      />
      <path
        className="st8"
        d="m165.4 346.8-2.1 1.8 2.1-1.8zM157.7 353.5l-1.6 1.4 1.6-1.4zM161.9 349.8l-4.2 3.7 4.2-3.7zM163.4 348.5l-1.4 1.2 1.4-1.2zM156.1 354.8l-.1.2.1-.2zM146.2 363.4l-3.1 2.7 3.1-2.7zM143.1 366.1l-.4.3.4-.3zM156 355l-5.9 5 5.9-5zM142.7 366.4l-5.9 5.1 5.9-5.1zM150.1 360l-3.9 3.4 3.9-3.4zM188.8 326.5l-1.2 1 1.2-1zM187.7 327.5l-4.8 4.2 4.8-4.2zM182.8 331.7l-3.9 3.4 3.9-3.4zM188.9 326.4zM169.9 342.9l-3.3 2.8 3.3-2.8zM173.3 339.9l-3.4 2.9 3.4-2.9zM166.7 345.7l-1.2 1.1 1.2-1.1zM178.9 335.1l-2.4 2.1 2.4-2.1zM176.5 337.2l-3.2 2.8 3.2-2.8zM131.8 375.9l-1.8 1.6 1.8-1.6zM119.3 386.7l-.7.6.7-.6zM118.6 387.3l-1.7 1.5 1.7-1.5zM116.9 388.8l-1.5 1.3 1.5-1.3zM120.6 385.6l-1.3 1.1 1.3-1.1zM115.4 390.1zM123.7 382.9l-3.1 2.7 3.1-2.7zM115.3 390.1l-.6.5.6-.5zM126.3 380.6l-.3.3.3-.3zM134.7 373.4l-1.3 1.1 1.3-1.1zM133.4 374.5l-1.6 1.4 1.6-1.4zM136.1 372.1l-1.4 1.2 1.4-1.2zM130 377.4l-1.6 1.4 1.6-1.4zM136.8 371.5l-.7.6.7-.6zM126 380.9l-2.3 2 2.3-2zM128.2 379l-1.9 1.7 1.9-1.7zM128.4 378.8l-.2.1.2-.1zM0 1008.5c303-300 506.9-243.8 633-277 55.9-14.7 165.6-81.4 192.9-132.4.5-1-.4 1.3.1.4 3.3-6.4 6.1-13 8.5-19.8l-.2-137.5c-5.9-54.6-5.2-104.3-.2-149L834 230s-389-68.2-645.1 96.4c0 0-177.9 103.3-190.7 220l1.8 517v-54.9z"
      />
    </g>
    <g id="Layer_9">
      <path
        className="st9"
        d="M828.9 597.1c.5-1-.4 1.3.1.4 15.8-30.9 22.1-69.5 16-103.7C791.9 196.8 931.7 30.6 960.1.5l-492.8 1c112 326.4 243.5 514.3 344.1 619.5 7.4-8.1 13.4-16.2 17.5-23.9z"
      />
      <path
        className="st10"
        d="M810.9 621.7c4.9-6 12.1-12.5 15.1-18.2.5-1 4.5-7 5-8 12.8-25 17.2-41.4 16-70-91.5-90.5-227.5-254.1-380-524 0 0 122.8 400.1 343.9 620.2z"
      />
    </g>
    <g id="Layer_7">
      <path
        className="st10"
        d="m452.8 236.4 1.8-3.2h-.1c.4-1.2.8-2.4 1.1-3.6l3.4-11.8c2.1-8.8 3.6-17.7 4.5-26.7.3-3 .9-6 .6-9.1v-.6l.2-.8c.8.5.8 1.3.9 2.1 2.8 16.6 8.3 32.2 17.7 46.6 5.3 8.2 12.9 14.3 21.4 19.5 2.8 1.7 5.6 3.2 8.5 4.8-.7.6-1.5.2-2.1 0-6.2-1.8-12.3-3.6-18.5-5.3-6.7-1.9-13.3-3.8-20-5.7-1.3-.4-2.5-1.1-4-1.1l-15.4-5.1z"
      />
      <pattern
        id="SVGID_1_"
        xlinkHref="#New_Pattern_Swatch_4"
        patternTransform="matrix(.78 0 0 -.78 -3235.08 -17076.701)"
      />
      <path
        d="M393.2 281.6c-12.6-5.6-24.5-12.8-35.3-21.3-4-3.1-7.8-6.5-11.4-10-.6-.5-1.1-1.1-1.5-1.8.8-.3 1.5-.9 1.9-1.7.4-.1.8-.3 1-.7.4-.1.6-.4.8-.7 1.1-.8 2.1-1.8 2.9-3 .4-.2.8-.6 1-1 1.3-1 2.4-2.3 3.3-3.7.8-.3 1.1-1 1.6-1.6 14.4-17 25-36.3 32.9-57.1.2-.6.6-1.1.3-1.7l3-5.7c4.5.9 9 1.7 13.5 2.6 12.1 2.5 24.3 2.9 36.6 2.5 6.2-.2 12.4-.2 18.6-.4 0 .8-.2 1.7-.6 2.4-5.4 13-11.6 25.8-18.6 38.1-12.2 21.9-26.3 42.4-43.8 60.5-1.3 1.4-2.5 3-4.2 3.9v-.9c0-.7-.1-1.4-1-1.4s-.9.7-.9 1.3c0 .5 0 .9-.1 1.4z"
        style={{
          fill: "url(#SVGID_1_)",
        }}
      />
      <path
        className="st9"
        d="M515.6 255.5c-.2.7-.9.8-1.5.9l-37.5 10c-.9.2-3.7 0-4.2-.5-2.3-2.5-4.5-5-6.8-7.5-1.5-1.7-3.7-2.6-6-2.3l-.5-.2c-.3-.9-.4-1.9-.2-2.9 2.3.3 4.5-1.3 5-3.6.5-1.8.8-3.6 1-5.4 1.9-.2 2.5-1.7 3.1-3.2 1.4 0 2.5.8 3.8 1.1 6.3 1.9 12.6 3.8 19 5.7 5.9 1.8 11.7 3.6 17.6 5.4.6.2 1.4.6 2 0l5.2 2.5z"
      />
      <path
        className="st12"
        d="m515.6 255.5-5.4-2.3c-2.7-1.6-5.4-3.1-8-4.8-8.1-5.2-15.2-11.4-20.3-19.7-8.9-14.5-14.1-30.4-16.8-47.1-.1-.8-.1-1.6-.9-2.1-.5-.7-.3-1.6.3-2.1 1 1.6 1.2 3.4 1.7 5.1.2 1 .7 1.9 1.2 2.7-.4.2-.3.5-.1.9.8 1.6 1.6 3.3 2.4 4.9-.1.8.1 1.7.5 2.4 7 19 18.2 35.3 32.8 49.3 4 3.8 7.7 7.8 11.8 11.5.4.3 1 .6.8 1.3z"
      />
      <path
        className="st13"
        d="M464 176.2c-3.5 8.4-7.3 16.8-11.4 25-11.2 22.3-24.1 43.4-39.9 62.8-4.9 6-10.1 11.7-15.6 17.2-.5.5-1 1.1-1.4 1.6l-.3.2c-.4.7-1.1.6-1.7.5v-.7c.7-.4 1.3-1 1.7-1.7 1.7-.9 2.9-2.5 4.2-3.9 17.4-18.1 31.5-38.7 43.8-60.5 7-12.3 13.2-25 18.6-38.1.4-.7.7-1.6.6-2.4l.2-.3c.4 0 .8.1 1.2.3zM469.7 191c-.8-1.6-1.5-3.3-2.4-4.9-.2-.4-.2-.6.1-.9 1.2.8 1.6 2.1 2.3 3.2 11.6 18.9 25.5 36.3 41.5 51.7 2.4 2.4 5 4.7 7.7 6.8.3.5.3 1.1 0 1.6-8.1-6.8-15.7-14.2-22.7-22.2a263.5 263.5 0 0 1-25.5-33.9c-.1-.6-.3-1.2-1-1.4z"
      />
      <pattern
        id="SVGID_2_"
        xlinkHref="#New_Pattern_Swatch_2"
        patternTransform="matrix(.78 0 0 -.78 -3169.69 -15079.281)"
      />
      <path
        d="M519 248.5c.3-.5.3-1.1 0-1.6.1-.8.1-1.6.2-2.3.1-.5.5-.8 1-.8.4.1.7.5.7.9v7.8c0 .5-.2 1-.8 1s-1-.5-1-1c0-1.4 0-2.7-.1-4z"
        style={{
          fill: "url(#SVGID_2_)",
        }}
      />
      <path
        className="st15"
        d="M404.8 285.5c.1 0 .1-.1.2-.2l1.5-.3c-.6.2-1.1.6-1.7.5z"
      />
      <path
        d="M464.1 180.3v.3c0-.1-.1-.1-.1-.2l.1-.1z"
        style={{
          fill: "#e8d1b7",
        }}
      />
      <path
        d="M453 250.4c1.9 1.2 3.7 2.4 6 2.8-.1 1-.1 1.9.2 2.9v.9c.1.9.8 1.9-.2 2.5-1 .5-2.2.5-3.1-.1-1.5-.8-2.7-2-3.5-3.6.1-1.6.2-3.2.3-4.9l.3-.5z"
        style={{
          fill: "#d46b6b",
        }}
      />
      <path className="st15" d="M467.9 239.8v-.3c0 .1.1.2.1.2l-.1.1z" />
      <path
        className="st9"
        d="M414.4 280.9c12.7-7.5 22.7-17.7 30.9-29.8.6-1.1 1.3-2.1 2.1-3.1 4.8-6.9 5.9-12.2 5.9-12.2l21.1 7 2.2 23.5-34.4 9.7c-1.7.1-3.3.5-4.9 1.1-9.3 2.5-18.7 4.9-28 7.4-.9.2-1.9.4-2.8.5 2.6-1.4 5.4-2.6 7.9-4.1z"
      />
      <path
        className="st12"
        d="M405.6 284c7.4-7.2 14.2-15 20.3-23.3 1.3-1.6 2.5-3.4 3.4-5.3l14.9-24.4c.4-.8.8-1.7 1.3-2.4 3.1-6 6-12.1 8.6-18.2 3.3-7.6 6-15.4 8.2-23.4.5-2 .4-4.2 1.8-5.9.3 3.1-.3 6.1-.6 9.1-1.1 12.1-3.3 24.1-6.6 35.8-.3 1-.6 2.1-.9 3.1-1.3 6.5-4.8 13.2-8.2 18.7-2.5 3.9-5.3 7.7-8.3 11.3-7 8.7-15.4 16.1-25 21.9-2.6 1.5-5.3 2.8-8 4.1l-1.5.3c0-.6.2-1.1.6-1.4z"
      />
      <pattern
        id="SVGID_3_"
        xlinkHref="#New_Pattern_Swatch_4"
        patternTransform="matrix(.78 0 0 -.78 -3235.08 -17076.701)"
      />
      <path
        d="M397.1 281.2c5.5-5.5 10.7-11.2 15.6-17.2 15.8-19.4 28.7-40.5 39.9-62.8 4.1-8.2 7.8-16.5 11.4-25l.3.1.2 1c-.7.5-.8 1.4-.3 2.1l-.2.8h-.1l.1.2v.4c-1.4 1.8-1.3 4-1.8 5.9-2.2 8-4.9 15.8-8.2 23.4-2.6 6.2-5.5 12.3-8.6 18.2-.7 1.4-1.5 2.8-2.4 4.1l-1 1.4-12.9 21.4c-.9 1.9-2 3.7-3.4 5.3-6.1 8.3-12.9 16.1-20.2 23.3-.4.3-.6.8-.6 1.3 0 .1-.1.1-.2.2-1 .3-2.1.3-3-.2-2-.9-4.1-1.6-6.2-2.5.6-.3 1.1-.9 1.6-1.4z"
        style={{
          fill: "url(#SVGID_3_)",
        }}
      />
      <path
        d="M393.5 172.2s-31 51.5-60.6 71.1"
        style={{
          fill: "none",
          stroke: "#c3ddd9",
          strokeMiterlimit: 10,
        }}
      />
      <pattern
        id="SVGID_4_"
        xlinkHref="#New_Pattern_Swatch_2"
        patternTransform="matrix(.78 0 0 -.78 -3169.69 -15079.281)"
      />
      <path
        d="M332.9 248.4c.6 0 1-.4 1-1v-6c0-.6-.4-1-1-1s-1 .4-1 1v5.9c0 .6.4 1 1 1.1z"
        style={{
          fill: "url(#SVGID_4_)",
        }}
      />
      <pattern
        id="SVGID_5_"
        xlinkHref="#New_Pattern_Swatch_2"
        patternTransform="matrix(.78 0 0 -.78 -3169.69 -15079.281)"
      />
      <path
        d="M394.6 287c.6 0 1-.4 1-1v-5.9c0-.6-.4-1-1-1s-1 .4-1 .9v6c-.1.6.4 1 1 1-.1 0 0 0 0 0z"
        style={{
          fill: "url(#SVGID_5_)",
        }}
      />
    </g>
    <g id="People">
      <path
        className="st22"
        d="M580.5 1225.4c-1.1 12.6.6 15.9-4.2 37.3-4.4 19.3-11.4 30.2-11.4 30.2 5.2 16 56.3 24.4 56.9 8.1.4-12.4.1-16.2 1-27.1 1.7-21 1.6-27 4.6-38 0-.1-45.5-25.7-46.9-10.5zM549.5 468.5c.3-1.8 17-18.8 17.3-20.6 5-35-4.5-73.4-4.5-73.4l53.9-.7 7.7 52.1.2 1.2c35.4 31.1 55.3 81.5 33.7 88.6-11.1 3.6-19.2 1.6-46.8-13.5l-54.3-12.3-7.2-21.4z"
      />
      <path
        className="st23"
        d="M613.7 502.1c4.5-3.2 9.6-5.6 14.9-7.1 5.7-1.6 12-2.4 17.9-.8.4.1.8 0 .9-.4.1-.4 0-.8-.4-.9h-.1c-6.1-1.6-12.7-.8-18.7.8-5.6 1.5-10.9 4-15.6 7.4-.8.6.3 1.5 1.1 1z"
      />
      <path
        className="st24"
        d="M622.9 387.1c-10.9 13.4-32.2 29.7-54.9 18.7l-1.4-10.2 54-23.5 2.3 15z"
      />
      <path
        className="st22"
        d="m539.8 305.8 51.6-20.5 33.4 42.8-6.4 18.9-28.9 18.7-18.7-1.5-23-40.7z"
      />
      <path
        className="st22"
        d="M624.9 364s-11.5 1.8-16.9-7.9c-.1-.1-26.1-54.3-46.3-50.3-23.9 4.7-32.6 14.1-30.2 38 1 10.1-3 14.9-6.7 20.7-.8 1.5-.3 3.4 1.2 4.3.8.4 1.7.5 2.6.2l3.5-.8c.8-.2 1.6.2 1.8 1 3.8 13 13.8 30.2 18.7 32.6 3 1.5 13.6 2.4 23 1.1 36-5.2 49.3-38.9 49.3-38.9z"
      />
      <path
        d="M538.2 339.8c-.3-1.9.7-2.5 3.6-2.4 2.9.2 5.6 1.1 8.2 2.5 5.1 2.9 6.4 8.3 5.1 7.1-2.2-2-4.2-3.4-9.7-5.3-3-1.1-7-.6-7.2-1.9z"
        style={{
          fill: "#824237",
        }}
      />
      <path
        d="M661 340.2c2.5-1.3 3.1-4.3 2.5-7-.7-3.3-2.5-6.3-5-8.5 2.7-5.7 5.3-13.9-1.8-16.1 3.3-2.4 3-6.9 1.5-10.8-.8-1.9-5.6-2.2-7.5-2.5 3.2-3 6.1-6.7 5.2-11.3-.3-1.8-2.4-3.6-2.5-5.1 0-.9 1-2.3 1-3.4s-.1-2.2-.4-3.2c-3.1-10.8-17.6-11.5-25.1-5.1-.5-3.3-3-5.9-6.2-6.7-3.7-1-7.3.6-10.1 2.9 1.1-4-.6-8.2-4.2-10.2-4.8-2.6-10.2-.5-13.8 3-.1-5.4-6.5-8.4-11.6-8.3-3.7.1-7.3 1.4-10.2 3.6-1.2 1.1-2.3 2.3-3.4 3.5-1.6 1.6-1.3 1.1-3.6.2-5.2-2.1-11.1-1-15.3 2.8-1.1 1-1.9 3-3 3.7-1.3.8-2.6-.8-4.3-1.4-1.3-.4-2.8-.5-4.2-.3-3 .5-5.6 2.4-7 5.1-1.1-1.7-2.9-3.3-5.1-2.9-1.1.2-2.1.8-2.8 1.6-.5.6-.8 1.2-1 1.9-4.8 1.4-10.2 3.2-12.6 7.9-1.5 3-1 6.5 1.9 8.1-4.4 2.7-7.8 7.1-7.2 12.5.4 3 2.6 6.1 5.4 6.2-2.7 3.1-3.6 7.3-2.5 11.3 1.1 4.5 5 6.3 8.8 4.1-.7 4.4 2.3 8.4 6.7 9.1 1.9.3 3.8-.1 5.4-1.1 3.1 6.6 15.3 5.1 19.1-.8 1.6-.2 3-.8 4.2-1.9.3 3.8 3.6 6.6 7.3 6.3 1.2-.1 2.3-.5 3.2-1.1-.3 5.2 4.8 11.9 10.1 9.6-.5 4.7.8 9.2 5.9 10.6 1.4.4 7.7 1 10.1-.1.9 2 3.9 4.5 4.8 5.2 2.2 2 5.6 5.5 5.6 5.5 1.3 1.9 3.2 3.5 5.4 3.7-.8 3.1.8 6.8 4.5 7.1 1.2.1 2.3-.2 3.2-.9-.1 3.8 3.1 8.1 6.9 7.8-3.6 7.7 6.6 18 11.3 14.5 2.1 2.6 5.4 3.8 8.7 3.4 3.8-.7 5-4 5.8-6.1 1.3 1.2 4.8 1.1 6.3-.1 2.7-2.2 3.4-6 1.7-9 5 2.3 10.5-6.6 7-10.5 5.6-1.4 7.1-10.1 2.1-13.1 5.1-2.4 3.3-10.7-1.2-13.7z"
        style={{
          fill: "#8f493b",
        }}
      />
      <path
        className="st27"
        d="M516.6 315.8c-.9-2.5-1.5-5.3-.2-7.8 1-2 3.1-3.2 5.4-3l-.7.7c-.4-3.5 1.1-6.9 3.9-9 2.5-1.8 6.6-1.7 7.7 1.7.2.8-1 1-1.2.2-.5-1.3-1.7-2-3.1-1.9-1.4.1-2.6.8-3.6 1.8-1.9 1.8-2.8 4.4-2.5 7 0 .4-.2.8-.7.7-1.9-.2-3.7.9-4.3 2.7-.8 2-.3 4.3.4 6.3.3.7-.9 1.3-1.1.6zM548 261.6c3.9.8 7 4 7.7 7.9l-1.2-.1c.9-2.3 3.7-2.9 5.9-2.2 2.5.9 4.3 3.1 4.5 5.8.1.8-1.2 1-1.2.2-.1-2-1.4-3.8-3.2-4.7-1.6-.7-4-.5-4.8 1.3-.1.3-.5.5-.8.3-.2-.1-.3-.2-.4-.4-.6-3.4-3.2-6.2-6.5-6.9-.9-.1-.8-1.3 0-1.2zM619.5 374.3c1.9-.7 3.5-2 4.6-3.7.6-.8 1-1.7 1.4-2.6.3-.8 1.1-2.3.4-3l1-.7c1.5 2.5 4.8 2.2 6.9.6 2.1-1.7 3-4.5 2.4-7.1-.1-.3.2-.7.5-.7.3-.1.7.2.7.5.7 3.4-.7 6.9-3.5 8.8-2.7 1.7-6.4 1.4-8.1-1.5-.4-.6.6-1.2 1-.7 1.5 1.8-.3 4.9-1.3 6.5-1.2 2.2-3.2 3.9-5.5 4.7-.8.2-1.3-.9-.5-1.1zM592.4 310.6c-1.1 2.6.1 5.6 2.6 6.8 2.6 1 5.5 0 6.8-2.5.3-.6 1.1-.1 1.1.4.1 2.6 2.1 4.7 4.6 5 2.5.2 4.8-1.4 5.5-3.8.2-.8 1.4-.3 1.2.4-1 3.4-4.5 5.4-7.9 4.4-2.7-.8-4.6-3.2-4.6-6.1l1.1.4c-1.7 3-5.4 4.2-8.5 2.8-3-1.6-4.3-5.2-3.1-8.3.3-.6 1.5-.2 1.2.5zM629.1 267.8c-1.8 1.6-2.9 3.8-3.2 6.1-.3 2.3 1.3 4.1 3.1 5.4.3.2.3.6.1.9-.1.1-.2.2-.4.2-2.4.1-4.3 2-4.5 4.3-.1 2 1.4 3.8 3.4 3.9.3 0 .7 0 1-.1.3-.1.7.2.7.5.1.3-.2.7-.5.7-2.6.6-5.2-1.1-5.8-3.8-.1-.3-.1-.5-.1-.8 0-3.1 2.4-5.8 5.5-6l-.2 1.1c-2-1.5-3.8-3.5-3.6-6.1.2-2.8 1.5-5.4 3.7-7.3.6-.4 1.4.5.8 1zM582.8 280.6c1.2 2.6 4.5 2.6 6.7 1.4 2.1-1.1 3.6-3.1 4.2-5.4.1-.3.5-.5.8-.3.1 0 .2.1.2.2 2.8 3.1 6.8 0 8.6-2.5.2-.2.6-.2.9 0 .2.2.2.5.1.7-1.2 1.9-2.9 3.3-5 4-2 .6-4.2.1-5.6-1.4l1.1-.2c-.8 3-3 5.4-5.8 6.5-2.7 1-6.1.4-7.4-2.4-.1-.3 0-.7.3-.8.3-.3.7-.1.9.2zM642.7 335.4c-1-2.6-1.1-5.6.9-7.8 1.7-1.9 4.6-2.2 6.6-.7l-.9.3c.4-1.6 1.6-2.9 3.2-3.4 1.8-.6 3.8-.5 5.6.2.3.1.5.5.4.8-.1.3-.5.5-.8.4-1.5-.6-3.1-.7-4.6-.3-1.3.4-2.2 1.5-2.5 2.7-.1.3-.5.5-.8.4 0 0-.1 0-.1-.1-1.6-1.2-3.9-1-5.1.6 0 0 0 .1-.1.1a6.02 6.02 0 0 0-.5 6.2c.1.8-1.1 1.3-1.3.6z"
      />
      <path
        className="st22"
        d="M604.3 346.6c-1.9 4.9-5.5 8-10.4 6.2-4.6-1.6-7.2-6.6-5.9-11.3 1.3-5.1 6-8.2 10.5-7.1 8.3 2 7.6 7.5 5.8 12.2z"
      />
      <path
        className="st24"
        d="M599.2 340.3c-.1-.3-.3-.5-.6-.4-1.4.4-2.6 1.2-3.6 2.3-1 1.3-1.6 2.7-1.8 4.3-.1.7 1 .8 1.1.1.2-1.1.5-2.1 1.1-3.1l.2.1.4.1h.1l.2.1c.1.1.2.1.3.2l.1.1.2.2.1.1v.1c0 .1 0 .1.1.2V345.3c0 .1 0 0 0 0v.2l-.1.2v.1l-.1.2-.2.2c.1-.1 0 0 0 0l-.1.1-.2.2-.1.1c.1-.1 0 0 0 0-.3.1-.4.5-.3.7s.5.4.7.3c.5-.3.8-.6 1.1-1.1.5-.8.6-1.8.3-2.6-.4-.8-1.1-1.4-1.9-1.6.7-.8 1.7-1.3 2.7-1.6.1 0 .3-.2.3-.4z"
      />
      <path
        d="M526.9 780c-2.3 35.1 13.4 108.5 19.1 168.1 3.2 33.8 9.8 83.2 12.7 132.6 6.4 109.4 3.6 123.2 17.1 170 0 0 6.9 2.9 25.1 2.4 20.3-.5 27.8-2.4 27.8-2.4 27.2-117.6 15.3-137 15.6-222 .5-130 29.3-174.6 7.1-264.5L526.9 780z"
        style={{
          fill: "#351377",
        }}
      />
      <path
        className="st29"
        d="M670.2 522.5c.9 32.9 8.2 82.5 2.3 128.6-7.6 58.8 2.5 101.2-18.6 124.2 0 0-17 24.5-63.9 23.5-49.1-1.1-63.1-18.8-63.1-18.8-7.2-3.4-8-47.5-8.5-60.4-1.2-32.2-6.5-82.8-2.7-139.4 2.6-39.5 8.5-73.6 31.6-108.9 0 0 6.8-10.3 11.8-13.3 0 0 29.9.4 73.9-23.3-.1.1 35.5 25.3 37.2 87.8z"
      />
      <path
        className="st22"
        d="M582.3 800c-4.5-.5-9-1.2-13.4-2.2-2.3-.5-4.4-1.3-6.5-2.5-1.5 4.2-3.2 8.5-5.1 13-1.1 2.6-2.9 6.1-6.1 12.3-8.7 16.8-16.8 25.7-15.3 27.5 3 3.7 14.7-3.2 18.1-7.2 0 0-.6 8-.8 20.3-.2 10.6 1.5 21.4 4.5 21.8 1.9.3 5.3-3.2 5.3-3.2.4 2.7 2.6 6.4 4.6 6.4 4.4 0 5.9-6.3 5.9-6.3 1.3 2.7 4 4.8 6.1 4.5 4.8-.8 5.6-12.5 5.6-12.5.7 1.3 1.9 2.2 3.3 2.6 3.6.7 5.4-7.6 6.5-16.8.7-5.8 2.7-12.5 3.7-24.8.7-8.2.8-14.5 1.3-17.9.8-5.2 1.9-10.3 3.5-15.4-6.7 1.9-14.4 1.2-21.2.4z"
      />
      <path
        className="st24"
        d="M563.2 878.6c-.9-5.6-2.1-11.5-1.2-17.2.9-5.4 2-10.8 3.5-16.1.1-.3-.1-.6-.4-.7s-.6.1-.7.4c-1.5 5.7-2.8 11.5-3.7 17.4-.8 5.4.5 11.1 1.4 16.5.1.7 1.2.4 1.1-.3z"
        style={{
          opacity: 0.6,
        }}
      />
      <g className="st31">
        <path
          className="st32"
          d="M573.8 878.8c-1.2-9.6-.4-19.3 2.6-28.5.2-.7-.8-1-1.1-.3-3 9.3-3.8 19.1-2.6 28.8.1.7 1.2.7 1.1 0z"
        />
      </g>
      <g className="st31">
        <path
          className="st32"
          d="M585.8 871.2c-.7-7.6.3-15.4 2.8-22.6.2-.7-.8-1-1.1-.3-2.5 7.4-3.5 15.2-2.8 22.9.1.7 1.2.7 1.1 0z"
        />
      </g>
      <path
        className="st29"
        d="M572 621.1c-.2.5 3.3 25.4 1.9 54.4-2.3 48.9 1.9 78-13.2 122.9 9.9 7 38.3 7.9 42.3 6.2 6.3-19.3 15.3-48.8 25.7-89.2 6.4-25.1 11.4-92.8 11.4-92.8-24.2 4.4-68.1-1.5-68.1-1.5z"
      />
      <path
        className="st33"
        d="M562.1 795.2c9.3-47.4 18.6-95 20.5-143.4.9-24-.8-47.6-2.9-71.5-2-23.5-4-48.5 2.5-71.5 3.2-11.6 9.2-22.9 19.2-29.9 9.4-6.6 21.5-9.1 32.3-4.6.7.3 1-.9.3-1.2-16.8-7.1-35.2 2.4-44.7 16.6-12.3 18.4-13.1 43-12.5 64.4.8 25.7 4.7 51.1 4.9 76.8.3 26.1-2 52.1-5.6 77.9-4 28.8-9.6 57.5-15.2 86-.1.9 1 1.2 1.2.4zM606.2 797.6c19.4-65.3 31.6-132.5 36.6-200.4 1.4-19.4 2.2-38.8 2.4-58.2 0-.3-.3-.6-.6-.6s-.6.3-.6.6c-.7 68.3-8.9 136.3-24.3 202.8-4.3 18.7-9.2 37.2-14.7 55.5-.2.7.9 1.1 1.2.3z"
      />
      <path
        className="st33"
        d="M565.8 778.7c13.1 6.2 27.5 7.3 41.8 7.4.3 0 .6-.3.6-.6s-.3-.6-.6-.6c-14 0-28.3-1.2-41.2-7.2-.7-.4-1.3.7-.6 1z"
      />
      <path
        className="st34"
        d="M625.7 812.7c5.9-.1 11.8-.8 17.6-2.1 5-1.1 10.8-2.3 14.6-5.9.6-.5-.3-1.4-.9-.9-3.8 3.5-9.8 4.7-14.7 5.7-5.5 1.2-11.1 1.8-16.7 1.9-.3 0-.6.3-.6.6.1.4.4.7.7.7zM555 1026.7c.1 5.4 4.2 9.2 8 12.5 3.7 3.2 7.8 6.5 12.8 6.5.3 0 .6-.3.6-.6s-.3-.6-.6-.6c-4.7 0-8.6-3.2-12-6.1s-7.5-6.6-7.6-11.6c0-.3-.3-.6-.7-.5-.2-.1-.5.1-.5.4zM643.6 1002.1c-3.7 14.1-8.5 30.9-23.4 37-.7.3-.4 1.5.3 1.2 15.3-6.2 20.4-23.2 24.2-37.8.1-.3-.2-.7-.5-.7-.2-.1-.5.1-.6.3z"
      />
    </g>
    <path
      d="M237.5 379.6c3-5 4.5-10.5 6.9-15.8 2.6-6 2.2-13-1.1-18.6-2.9-4.9-7.8-8.5-9.8-13.9-3-8.1 1.5-17.8-2.3-25.6-14.9 26-25.9 54-32.5 83.2-.7 3.2-1.1 7.2 1.7 9l-.3-.6c5.2-1 11.9 10.4 17.1 11.4 9.9 1.9 4.4 10.9 16.1 11.1-2.7-5.6-1.4-30.9 4.2-40.2z"
      style={{
        fill: "#0f192d",
      }}
    />
    <path
      d="M175.8 1009.3c-10.4 3.8-22.1 2.5-31.4-3.6-.7-.5.1-1.5.8-1.1 8.9 5.8 20.1 7.1 30.1 3.5.7-.3 1.3.9.5 1.2z"
      style={{
        fill: "#bc835a",
      }}
    />
    <path
      className="st37"
      d="M205.8 679.4s-33.2.9-48.6.9c-14.4 0-57.3-1.2-57.3-1.2-15.3 27.6-9.5 94.9-10.5 103.2-8.2 69.4 24.3 80 20.3 159.9 0 0 10-5.7 40.6-5.7 23.1 0 46.8 5.3 46.8 5.3-2.2-59 28.5-144 8.7-262.4z"
    />
    <pattern
      id="SVGID_6_"
      xlinkHref="#New_Pattern_Swatch_6"
      patternTransform="matrix(1.05 0 0 -1.05 -578.78 -16364.097)"
    />
    <path
      d="M159.3 433.4c8.5 3.3 37.3 19.9 37.3 19.9 15.7 15.3 19.7 27.5 24.3 42.5 6.4 21.1 7.7 59 7.7 73.3 0 21.9 3.1 40.7 2.6 60.9-1.2 47.2 8.4 121.9 8.4 121.9-10 7.1-46.1 3.2-82 6.3-55 4.8-86.4-6.3-86.4-6.3 3-14.8 10.4-68.7 6.3-128.5-6.4-92.9 11.5-157.5 33.7-186.9 0 .2 29.9-10.2 48.1-3.1z"
      style={{
        fill: "url(#SVGID_6_)",
      }}
    />
    <path
      className="st39"
      d="M230.4 763.4c-10.6-16.7-21.2-38-33.9-71.3-11.6-.6-25.1 6.6-34.2 13.2 16.9 28.3 35 51.7 39.4 65.2 1.7 5.2-.4 11.6 4.5 24.1 2.6 6.6 11.2 8 14.4 18.8 2.1 6.9 5.7 9.5 6.4 9.8 4.4 2 16-15.1 15.6-33.9-.2-13.1-10.1-22.6-12.2-25.9zM196.6 456.9c-.3-1.8-15.5-18.8-15.7-20.6-4.6-35 4-73.4 4-73.4l-49-.7-7 52-.2 1.2c-32.1 31.2-50.2 81.5-30.5 88.6 10.1 3.6 17.4 1.6 42.6-13.4l49.4-12.3 6.4-21.4z"
    />
    <path
      className="st40"
      d="m180.6 392.8-.4 5c-23.8.1-33.2-28.2-33.2-28.2 8.1 1.7 33.6 23.2 33.6 23.2z"
    />
    <path
      className="st39"
      d="M140.4 345.8c0-.2 1.7-5.9 1.8-8.3.4-30.5 19.7-52.6 42.8-54.6 14.6-1.3 25.1-1.7 31.4 6 5.3 6.5 7.4 19.8 7.8 32.1.3 11.5 5.4 16.3 10.4 22.2 1.2 1.6.8 3.8-.8 4.9-.8.6-1.9.8-2.9.6l-4-.4c-.9-.1-1.7.5-1.9 1.4-1.1 7.5-3.2 14.8-6.2 21.7-6.4 13.5-14.4 25.6-35.5 21.9-23.5-4.2-37.7-25.9-42.7-33.8-.4-4.5-.4-9.1-.2-13.7z"
    />
    <path
      className="st41"
      d="M210.4 333.4c.2 1.3 1.5 2.2 2.8 2 1.3-.2 2.2-1.5 2-2.8-.2-1.2-1.2-2-2.4-2-1.4.1-2.5 1.4-2.4 2.8z"
    />
    <path
      className="st42"
      d="M195.7 926.9c-13-4.7-27.8-5-41.5-5.7-14.5-.8-29-.4-43 3.5-.4.1-.7-.1-.9-.5-.1-.4.1-.7.5-.9 14.2-3.9 28.8-4.3 43.4-3.5 13.8.7 28.7 1 41.9 5.8.8.3.4 1.6-.4 1.3zM107.1 813.2c.2 7 .4 14 .5 21 .2 1.1-.1 2.2-.8 3-.9.7-2 1.2-3.1 1.5-3.2 1.1-6.5 1.9-9.8 2.6-.9.2-1.2-1.2-.4-1.3 2.8-.5 5.6-1.3 8.4-2.1 1.2-.4 3-.7 3.9-1.6s.4-3.4.4-4.7l-.4-18.3c0-.4.3-.7.7-.7.3-.1.6.2.6.6z"
    />
    <path
      className="st23"
      d="M140.4 490.5c-3.9-3.2-8.3-5.6-13.1-7-5-1.6-10.6-2.4-15.7-.8-.4.1-.7-.2-.8-.6 0-.3.1-.6.4-.8 5.3-1.6 11.2-.8 16.4.8 5 1.6 9.6 4.1 13.7 7.4.8.6-.2 1.6-.9 1z"
    />
    <path
      className="st40"
      d="M218.3 796.8c7.9 5 10.6 14.5 11 23.3 0 .9-1.3.9-1.4 0-.4-8.3-2.8-17.4-10.3-22.1-.7-.5 0-1.7.7-1.2zM232.2 796.7c1.4 2.6 2.4 5.5 2.8 8.5.6 3 1.2 6.1.3 9.2-.1.4-.5.6-.8.5-.4-.1-.6-.5-.5-.8.8-2.9.2-5.8-.4-8.7-.4-2.8-1.3-5.4-2.6-7.9-.2-.3 0-.8.3-.9.4-.3.7-.2.9.1zM240.5 794.3c.5 2 .7 4.1.5 6.2 0 .4-.3.7-.7.7-.4 0-.7-.3-.7-.7.2-2 0-3.9-.5-5.8-.1-.4.1-.8.5-.8.5-.1.8.1.9.4z"
    />
    <pattern
      id="SVGID_7_"
      xlinkHref="#New_Pattern_Swatch_6"
      patternTransform="matrix(1.05 0 0 -1.05 -578.78 -16364.097)"
    />
    <path
      d="M192.7 451.5s-58.1-.7-78.5-19.3c0 0-21.3 23.2-25.8 63.8l6.9 9.7 30.9 2.4 41.7-10.5 34-16 1.6-16.1c-.1-.1-11-14.1-10.8-14z"
      style={{
        fill: "url(#SVGID_7_)",
      }}
    />
    <path
      className="st44"
      d="M214.9 325.1c1.5-1.2 1.3-2.1-.8-3.8-2.2-1.6-4.8-2.8-7.5-3.4-5.6-1.2-11.9 1.1-10.1 1.1 4.2-.1 8.4.7 12.3 2.3 2.7 1.1 5.7 4.1 6.1 3.8z"
    />
    <path
      className="st44"
      d="M242.3 298.5c-.5-9.4-3.6-19-10.2-25.6-3.8-3.7-8.4-6.4-13.1-9l-15.8-8.9c-3.9-2.2-7.9-4.4-12.2-5.3-5.2-1.1-11.5.3-14.2 4.9-5.6-5.3-13.5-7.5-21.1-7.3s-15 2.8-21.9 6.2c-9 4.4-17.8 10.7-21 20.1-1.4 4.2-1.7 8.8-3.6 12.8-5.1 11-20.8 15.2-23.5 27-.3 1.5-.5 3.1-.4 4.6-.2 4.6 1.3 9.2 2.5 13.7.7 2.4 1.1 4.9 1.2 7.4 0 2.5-.8 5-2.2 7.1-1.7 2.5-4.3 4.1-6.4 6.3 0 0-12 19.1 14.5 23.1s12.1-5 42 8.5c-1.4-2.1 0-4.9.6-6.6 1.2-3.5 3.4-6.8 3.5-10.5V365.1c.1-5.8-5.1-10.2-9.5-14s-8.6-7.9-10.7-13.2c-.6-1.7-1-3.4-1.1-5.2.1-3.4 1.5-6.6 3.9-8.9 4.3-3.8 10.7-3.6 16.4-4.5 8-1.3 15.9-5.5 19.8-12.6 2.7-5 3.3-10.9 5.7-16 5.6-12.1 22.1-17.7 33.9-11.5 0 0 24.1 13.6 26.5 31.2l.4 5.4 3.2-2.2c1.2 3.2 2.1 6.5 2.7 9.9 7.6-3.9 10.3-13.5 10.1-22.2.1-.8.1-1.8 0-2.8z"
    />
    <path
      className="st41"
      d="M542.3 351.8c-.1 1.3-1.3 2.3-2.6 2.2s-2.3-1.3-2.2-2.6c.1-1.1 1-2.1 2.1-2.2 1.5-.1 2.7 1.1 2.7 2.6z"
    />
    <path
      className="st45"
      d="m540.4 375.9 1.3 2.7c.2.4.6.6 1 .5 1.4-.5 4.5-1.4 6.7-.5 2.8 1.2-2.3-5.9-8.5-4-.5.2-.7.7-.5 1.2v.1z"
    />
    <path
      className="st44"
      d="M212.4 283.1c-10-2.3-23.4 3.7-30.4 10.8-3.4 3.3-5.6 7.7-6.1 12.4-.7 6.7 3.2 14.2-.2 20.4-3 5.5-9.5 8.1-14.8 11-5 2.7-9.9 6-12.7 11.1-1.3 2.2-2 4.7-2.2 7.2 0 1.3.1 2.5.3 3.8.1 2.2-.6 3.2-1.6 5.1-3.2 6-5.4 12.5-6.4 19.3l5.8-1.5-17.7-21.5-8.2-10c-2.6-3.2-6.7-6.8-7-11.2-.2-4 2.2-8.9 3.6-12.4 1.6-3.7 3.3-7.4 5.2-10.9 3.8-6.8 8.1-13.4 12.8-19.6 4.5-6.3 9.4-12.2 14.8-17.8 7-6.9 15.2-7.5 24.6-7.8 8.2-.3 17.7-1.3 25.8.3 6.9 1.5 7.6 10.8 11.6 15.6 2.9 3.4 7.8-1.5 4.9-4.9-3.8-4.5-4-10.9-8.8-14.7-5.1-4-12.6-3.3-18.6-3.4-14.2-.2-31.2-1.8-42.6 8.3-10.4 9.2-19.2 22-26.5 33.8-3.8 6.1-7.1 12.6-9.9 19.3-2.4 5.8-5.3 12.6-3 18.9 2.7 7.4 10.2 14 15.1 20l19 23c1.6 1.9 5.4 1 5.8-1.5.9-6.5 3-12.7 6.1-18.4 1-1.9 2.2-3.7 2.3-5.9.2-2.6-.9-5 0-7.6 3.3-10.3 18.3-12.4 25.2-19.8 3.1-3.1 5-7.2 5.4-11.6.5-5.9-2.3-11.9-.8-17.6 1.3-4.9 5.5-8.2 9.8-10.5 4.9-2.7 12-6 17.7-4.7 4.2.8 6-5.9 1.7-7z"
    />
    <path
      className="st44"
      d="M209.4 286.5c-3.7-1.2-7.7-.1-11.4 1.1-9.1 3-19.1 8.4-20.7 17.8-1.1 6.5 2.3 13.3.6 19.7-1.3 5.2-5.7 9-10.3 11.7s-9.6 4.8-13.8 8.1-7.3 8.6-6.4 13.9c.2.8.3 1.6.4 2.4-.2 1.4-.7 2.7-1.5 3.8-3.6 6.2-5.9 12.9-6.9 20l-29.1-35.2c-2-2.4-4.1-5-4.7-8.1-.5-2.9.3-5.8 1.2-8.6 6.4-19.2 18.5-36.1 31.7-51.5 3.5-4.1 7.3-8.3 12.1-10.7 4.7-2.3 10.1-2.6 15.3-2.9 8.6-.4 17.2-.4 25.9-.1 3.2.1 6.6.3 9.2 2.2 4.7 3.4 4.9 10.5 8.8 14.8"
    />
    <path
      className="st44"
      d="M211.8 289.7c8.6 7.4 13.3 18.4 12.7 29.8h6.9c-1.5-16.1-7.7-32.7-24.1-38.6-4.2-1.5-6 5.2-1.9 6.7 13.2 4.8 17.8 19.2 19 31.9.4 4.4 6.7 4.5 6.9 0 .7-13.2-4.8-26-14.7-34.7-3.3-2.9-8.2 2-4.8 4.9z"
    />
    <path
      className="st45"
      d="m217.3 360-1.3 2.8c-.2.4-.6.6-1 .5-1.4-.5-4.5-1.4-6.7-.5-2.8 1.2 2.3-6 8.5-4 .5.1.7.7.5 1.2z"
    />
    <path
      className="st39"
      d="M162.3 705.3S124 604.5 121.1 595.2l-8.7-29.4 50.9-12.4s23.6 112.1 33.1 138.7c8.7 24.3-4.5 27.4-4.5 27.4l-29.6-14.2z"
    />
    <path
      d="M96.9 525.6s1 25.5 5 37.4c.8 2.4 3.1 3.9 5.5 3.7 8-.5 28.4-2.8 60.7-14.2 2.2-.8 3.6-3.1 3.2-5.4-1.5-9.2-5.9-31.8-13.5-40.5"
      style={{
        fill: "none",
        stroke: "#bdb5c6",
        strokeMiterlimit: 10,
      }}
    />
    <pattern
      id="SVGID_8_"
      xlinkHref="#New_Pattern_Swatch_6"
      patternTransform="matrix(1.05 0 0 -1.05 -578.78 -16364.097)"
    />
    <path
      style={{
        fill: "url(#SVGID_8_)",
      }}
      d="m107.5 560 4.9 5.8 26.4-4.4 24.6-8-5.8-13.4z"
    />
    <path
      className="st37"
      d="M606.4 1287.5c-2.9 4.2-7.8 7.8-13.7 7.8-4.6 0-9.8-2.6-14.4-5.8 5.1-5.1 5.5-8.9 1.8-14.7s-15.2 2.9-15.2 2.9c-10.4 7.1-21.1 13.7-32.1 19.6-11.4 6-23.8 10.1-36.5 12-4.5.7-8.9 1.9-10.8 3.8-4.8 4.8-4.3 13.8-.4 16.4 0 9.9 13.6 17 29.9 17h87.4c6.7 0 13.3-.7 19.8-2.1 4.6-1 9.1-2.6 13.3-4.7 3.3-1.7 4.7-5.6 3.3-9l-3.5-8.5c4.1-5.7-3.9-24.9-8.5-35-2.1-4.5-1.2-5.3-5.9-6.7"
      id="Layer_11"
    />
    <path
      className="st48"
      d="M33.1 1125.9s36.1-7.2 46.8 23.4M266.9 1262.3s28.7 0 25.6 27.3"
    />
    <path
      className="st49"
      d="M33.1 1254.1s11.8-14.8 29.1-4.3M73.4 1282.3s8.4-10.4 20.9 0"
    />
    <path
      className="st6"
      d="M130.9 1314.2H0v37.3h130.9c10.3 0 18.6-8.3 18.6-18.6 0-10.4-8.3-18.7-18.6-18.7z"
    />
  </svg>
  </StyledBackgroundWrapper>
  )
}

export default SvgSexThreeEnd